import PaymentCorfimPage from './PaymentCorfimPage'

export default PaymentCorfimPage
